"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var _commercialMessage = _interopRequireDefault(require("@ingka/commercial-message"));
var _price = _interopRequireDefault(require("@ingka/price"));
var _Notes = _interopRequireDefault(require("./elements/Notes"));
var _rating = _interopRequireDefault(require("@ingka/rating"));
var _PriceAddons = _interopRequireDefault(require("./elements/PriceAddons"));
var _ProductName = _interopRequireDefault(require("./elements/ProductName"));
var _EnergyClass = _interopRequireDefault(require("./elements/EnergyClass"));
var _ProductDescription = _interopRequireDefault(require("./elements/ProductDescription"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const PriceModule = _ref => {
  let {
    prefix,
    productName,
    productDescription,
    commercialMessageProps,
    priceOfferType,
    comparisonPriceProps,
    currentPriceProps,
    secondaryCurrencyPriceProps,
    secondaryCurrencyComparisonPriceProps,
    ratingProps,
    priceAddons,
    notes,
    energyClass,
    productNameHeadingTag,
    variant,
    size,
    className,
    ...other
  } = _ref;
  const baseClass = `${prefix}price-module`;
  const withCommercialMessage = (priceOfferType === 'nlp' || priceOfferType === 'new' || priceOfferType === 'family' || commercialMessageProps) && commercialMessageProps?.message !== '';
  const classes = (0, _classnames.default)(baseClass, `${baseClass}--${variant}`, `${baseClass}--${size}`, withCommercialMessage && `${baseClass}--with-commercial-message`, priceOfferType && `${baseClass}--${priceOfferType}`, className);
  const comparisonPrice = comparisonPriceProps && priceOfferType === 'tro' ? _react.default.createElement("span", {
    className: `${baseClass}__comparison-price`
  }, _react.default.createElement(_price.default, _extends({}, comparisonPriceProps, {
    size: "small",
    strikeoutPrice: true,
    prefix: prefix,
    regularFontWeight: variant === 'list'
  }))) : null;
  const secondaryCurrencyComparisonPrice = secondaryCurrencyComparisonPriceProps && priceOfferType === 'tro' ? _react.default.createElement("span", {
    className: `${baseClass}__comparison-price`
  }, _react.default.createElement(_price.default, _extends({}, secondaryCurrencyComparisonPriceProps, {
    size: "small",
    strikeoutPrice: true,
    prefix: prefix,
    regularFontWeight: variant === 'list'
  }))) : null;
  const defaultRatingSize = size === 'small' ? true : false;
  return _react.default.createElement("div", _extends({
    className: classes
  }, other), _react.default.createElement("div", {
    className: `${baseClass}__information`
  }, withCommercialMessage && _react.default.createElement(_commercialMessage.default, _extends({
    prefix: prefix,
    subtle: true
  }, commercialMessageProps, {
    variant: priceOfferType
  })), _react.default.createElement(_ProductName.default, {
    productNameHeadingTag: productNameHeadingTag,
    prefix: prefix,
    name: productName
  }, _react.default.createElement(_ProductDescription.default, {
    prefix: prefix,
    description: productDescription
  })), variant === 'list' && _react.default.createElement(_EnergyClass.default, {
    prefix: prefix
  }, energyClass)), _react.default.createElement("div", {
    className: `${baseClass}__price`
  }, _react.default.createElement("div", {
    className: `${baseClass}__primary-currency-price`
  }, variant !== 'list' && comparisonPrice, _react.default.createElement(_price.default, _extends({
    bti: variant !== 'list' && priceOfferType === 'bti',
    className: `${baseClass}__current-price`,
    prefix: prefix
  }, currentPriceProps, {
    fixedSize: variant === 'list'
  })), variant === 'list' && comparisonPrice, variant !== 'list' && _react.default.createElement(_EnergyClass.default, {
    prefix: prefix
  }, energyClass)), secondaryCurrencyPriceProps && _react.default.createElement("div", {
    className: `${baseClass}__secondary-currency-price`
  }, variant !== 'list' && secondaryCurrencyComparisonPrice, _react.default.createElement(_price.default, _extends({
    bti: variant !== 'list' && priceOfferType === 'bti',
    className: `${baseClass}__secondary-current-price`,
    prefix: prefix
  }, secondaryCurrencyPriceProps, {
    fixedSize: variant === 'list'
  })), variant === 'list' && secondaryCurrencyComparisonPrice)), _react.default.createElement(_PriceAddons.default, {
    prefix: prefix
  }, priceAddons), variant !== 'list' && _react.default.createElement(_Notes.default, {
    prefix: prefix
  }, notes), ratingProps && variant !== 'list' && variant !== 'inspirational' && _react.default.createElement(_rating.default, _extends({
    prefix: prefix,
    small: ratingProps?.small ? ratingProps.small : defaultRatingSize
  }, ratingProps, {
    className: (0, _classnames.default)(`${baseClass}__rating`, ratingProps.className),
    onClick: variant === 'informational' ? ratingProps.onClick : null
  })));
};
PriceModule.defaultProps = {
  prefix: '',
  variant: 'compact',
  size: 'medium',
  productNameHeadingTag: 'div',
  priceOfferType: 'regular'
};
var _default = PriceModule;
exports.default = _default;